module.exports = __webpack_public_path__ + "img/blank-comic-book_B0997QPH9P.7919998d.jpg";